import styles from './SkeletonLoader.module.css';

interface SkeletonLoaderProps {
	rows?: number;
	columns?: number;
}

function cellClass(index: number, total: number): string {
	if (index === 0) return [styles.skeleton, styles.cell, styles.cellWide].join(' ');
	if (index === total - 1) return [styles.skeleton, styles.cell, styles.cellNarrow].join(' ');
	return [styles.skeleton, styles.cell].join(' ');
}

export function SkeletonLoader({ rows = 5, columns = 4 }: SkeletonLoaderProps) {
	// Static placeholder rows — index keys are acceptable for pure visual skeletons
	// that never reorder, have no state, and exist only as loading placeholders.
	const rowKeys = Array.from({ length: rows }, (_, i) => `sk-row-${i}`);
	const colKeys = Array.from({ length: columns }, (_, j) => `sk-col-${j}`);

	return (
		<>
			{rowKeys.map((rowKey, _i) => (
				<tr key={rowKey}>
					{colKeys.map((colKey, j) => (
						<td
							key={colKey}
							style={{ padding: '8px 12px', borderBottom: '1px solid var(--color-stone-100)' }}
						>
							<div className={cellClass(j, columns)} />
						</td>
					))}
				</tr>
			))}
		</>
	);
}
